import { useEffect, useState } from "react";
import {
  Button,
  MenuItem,
  FormControl,
  Grid,
  InputLabel,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  tableCellClasses,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Cookies from "universal-cookie";
import axios, { AxiosInstance } from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { DataRef } from "../../../../types/DataRef";
import CheckAttr from "../../../../utils/CheckAttr";
import {
  dataConsildationPar,
  dataTypeConsolidation,
  IConsolidationCommission,
} from "./IConsolidationCommission";
import {
  AllMounth,
  profilToAccessCommissionCommercialGRC,
} from "../../../../constants/Constants";
import { ConnectedUser } from "../../../../utils/utils";
import { urlApi } from "../../parametrage/Pays/RowPays";
import { StyledTableCell, tableStyle } from "../../parametrage/Pays/Pays";
import RowConsolidationCommission from "./RowConsolidationCommission";
import { yearsToDisplayCommission } from "../MainCommission";

interface FilterParams {
  month?: string;
  year?: string;
  client?: string;
  operation?: string;
}

const initialFilter: FilterParams = {
  month: "",
  client: "",
  operation: "",
  year: String(new Date().getFullYear()),
};

const ConsolidationCommission = () => {
  const userConnected = ConnectedUser();
  const isCommercialDRC = profilToAccessCommissionCommercialGRC.includes(
    userConnected?.profils?.libelle
  );

 
  // Filter
  const [filterParams, setFilterParams] = useState<FilterParams>(initialFilter);
  const [typeConsolidation, setTypeConsolidation] = useState<number>(1);
  const [consolidationPar, setConsolidationPar] = useState<number>(0);
  const [filterUser, setFilterUser] = useState<number | string>("");

  // Data ref
  const [allUserRef, setAllUserRef] = useState<DataRef[]>([]);
  const [allClient, setAllClient] = useState<DataRef[]>([]);
  const [allOperation, setAllOperation] = useState<DataRef[]>([]);

  // Data
  const [allUserWithConsolidation, setAllUserWithConsolidation] = useState<
    IConsolidationCommission[]
  >([]);

  // Autre
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const AllMounthCorriger = Number(filterParams?.year) ===  new Date().getFullYear() ? AllMounth?.filter((mounth) => mounth?.id <= new Date().getMonth() + 1) : AllMounth;

  const cookies = new Cookies();
  const token: string = cookies.get("jwt");
  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  // HandleChange
  const handleChangeFilter = (e: any) => {
    const { name, value } = e.target;

    if (name === "client") {
      setFilterParams({
        ...filterParams,
        operation: "",
        [name]: value,
      });
    } else {
      setFilterParams({
        ...filterParams,
        [name]: value,
      });
    }
  };

  // Get Data
  const getDataRef = () => {
    http
      .get("commission/alluser/hasCommission")
      .then((res) => {
        setAllUserRef(res.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
      });

    http
      .get("operation/get-clients/distinct")
      .then((res) => {
        setAllClient(res.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
      });
  };

  const getOperationByClient = () => {
    setIsLoading(true);
    CheckAttr(filterParams?.client) &&
      http
        .get(`operation/get-operations/via-client/${filterParams?.client}`)
        .then((res) => {
          setAllOperation(res.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
  };

  const getUserWithConsolidation = () => {
    setIsLoading(true);
    const data = {
      userId: isCommercialDRC ? userConnected?.id : filterUser,
      annee: filterParams?.year,
      mois: filterParams?.month,
      operation: filterParams?.operation,
      client: filterParams?.client,
      typeConsolidation,
      consolidationPar
    };
    http
      .post(`commission/alluser/consolidation-commission`,data)
      .then((res) => {
        setAllUserWithConsolidation(res.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // UseEffect
  useEffect(() => {
    getUserWithConsolidation();
  }, [filterParams, filterUser]);

  useEffect(() => {
    getOperationByClient();
  }, [filterParams?.client]);
  useEffect(() => {
    getDataRef();
  }, []);

  return (
    <>
      <Grid container spacing={0.5} columns={{ xs: 6, sm: 10, md: 12 }}>
        <Grid item xs={2} sm={2} md={1.5}>
          <FormControl fullWidth>
            <InputLabel
              id="demo-simple-select-label"
              color="warning"
              sx={{ mt: -1 }}
              shrink={CheckAttr(typeConsolidation)}
            >
              Type Consolidation
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="pays"
              sx={{ background: "#fff" }}
              size="small"
              color="warning"
              label="Pays"
              value={typeConsolidation}
              onChange={(e) => {
                setFilterParams({
                  ...filterParams,
                  month: "0",
                });
                setTypeConsolidation(e.target.value as number);
              }}
            >
              <MenuItem value={0}></MenuItem>
              {dataTypeConsolidation.map((type) => (
                <MenuItem key={type?.id} value={type?.id} dense>
                  {type?.libelle}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2} sm={2} md={1.5}>
          <FormControl fullWidth>
            <InputLabel
              id="demo-simple-select-label"
              color="warning"
              sx={{ mt: -1 }}
              shrink={CheckAttr(consolidationPar) && consolidationPar !== 0}
            >
              Consolidation par
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="pays"
              sx={{ background: "#fff" }}
              size="small"
              color="warning"
              label="Pays"
              value={consolidationPar}
              onChange={(e) => {
                setFilterParams({
                  ...filterParams,
                  month: "0",
                });
                setConsolidationPar(e.target.value as number);
              }}
            >
              <MenuItem value={0}></MenuItem>
              {dataConsildationPar.map((type) => (
                <MenuItem key={type?.id} value={type?.id} dense>
                  {type?.libelle}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2} sm={2} md={1.5}></Grid>
        <Grid item xs={0} sm={2} md={1.5}>
          <FormControl fullWidth>
            <InputLabel
              id="demo-simple-select-label"
              color="warning"
              sx={{ mt: -1 }}
            >
              Client
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              sx={{ background: "#fff" }}
              size="small"
              color="warning"
              label="Age"
              value={filterParams?.client}
              onChange={handleChangeFilter}
              name="client"
            >
              <MenuItem value={undefined} dense></MenuItem>
              {allClient.map((cl) => (
                <MenuItem key={cl?.id} value={cl?.id} dense>
                  {cl?.libelle}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={0} sm={2} md={1.5}>
          <FormControl fullWidth>
            <InputLabel
              id="demo-simple-select-label"
              color="warning"
              sx={{ mt: -1 }}
            >
              Operation
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              sx={{ background: "#fff" }}
              size="small"
              color="warning"
              label="operation"
              value={filterParams?.operation}
              onChange={handleChangeFilter}
              name="operation"
            >
              <MenuItem value={undefined} dense></MenuItem>
              {allOperation.map((op) => (
                <MenuItem key={op?.id} value={op?.id} dense>
                  {op?.libelle}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={0} sm={2} md={1.5}>
          <FormControl fullWidth>
            <InputLabel
              id="demo-simple-select-label"
              color="warning"
              sx={{ mt: -1 }}
            >
              Commerciaux/DRC
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              sx={{ background: "#fff" }}
              size="small"
              color="warning"
              label="Age"
              value={filterUser}
              onChange={(e: any) => setFilterUser(e.target.value)}
              disabled={isCommercialDRC}
            >
              <MenuItem value={undefined} dense></MenuItem>
              {allUserRef.map((userRef) => (
                <MenuItem key={userRef?.id} value={userRef?.id} dense>
                  {userRef?.libelle}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={4} sm={4} md={1.5}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel
              htmlFor="Mois"
              color="warning"
              shrink={CheckAttr(filterParams?.month) && filterParams?.month !== "0"}
              sx={{ mt: -1 }}
            >
              Mois
            </InputLabel>
            <Select
              id="Mois"
              native
              color="warning"
              sx={{ background: "#fff" }}
              size="small"
              value={filterParams?.month}
              name="month"
              onChange={handleChangeFilter}
              label="Mois"
              disabled={typeConsolidation !== 2}
            >
              <option value={0}></option>
              {AllMounthCorriger.map((m) => (
                <option value={m.id}>{m.mounth}</option>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={4} sm={4} md={1.5}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel
              htmlFor="year"
              color="warning"
              shrink={CheckAttr(filterParams?.year)}
              sx={{ mt: -1 }}
            >
              Année
            </InputLabel>
            <Select
              id="year"
              native
              color="warning"
              sx={{ background: "#fff" }}
              size="small"
              name="year"
              value={filterParams?.year}
              onChange={handleChangeFilter}
              label="year"
              inputProps={{
                name: "year",
              }}
            >
              <option value={0}></option>
              {yearsToDisplayCommission.map((y) => (
                <option value={y}>{y}</option>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <br></br>

      <TableContainer component={Paper} style={tableStyle}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell />
              <StyledTableCell align="center">prenom</StyledTableCell>
              <StyledTableCell align="center">Nom</StyledTableCell>
              <StyledTableCell align="center">Email</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {allUserWithConsolidation?.map((userWithconso) => (
              <RowConsolidationCommission
                userWithConsolidation={userWithconso}
                consolidationPar={consolidationPar}
                typeConsolidation={typeConsolidation}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default ConsolidationCommission;
